export default "__VITE_ASSET__CIZoUuud__"